<template>
  <div class="no_spaces_for_div blog_category_link_mini col-12  col-md-8 col-lg-6 col-xl-6">
  <router-link   :to="{'name':'category_blog','params':{'alias':category.alias}}" class="category-link" tag="a">
    <div class=" row">
      <div class="col-3 col-sm-3 col-md-4 col-lg-3">
        <img :src="image_url+category.image" style="max-height: 100px" class="img-thumbnail" />
      </div>
      <div class="col-9 col-sm-9 col-md-8 col-lg-9 title_blog_category">
        <p class="vertical_center">{{ category.title }}</p>
      </div>

    </div>
  </router-link>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: 'CategoryCardPost',
  props: {
    category:Object,

  },
  data(){
    return {
      'image_url':""
    };
  },
  mounted() {
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;

  },
}
</script>

<style scoped>

</style>